import { NTdevUtils } from './modules/ntdev/utils.js';
import { UI } from './modules/theme/ui.js';

document.addEventListener('DOMContentLoaded',() => {
    const utils = new NTdevUtils();

    // Utilidades
    utils.imgToSVG();
    utils.imgToSVG('.imgSVGLink img');
    utils.scrollTo('.__scrolling', 1000, 1);
    // utils.modalInit();
    utils.buttonMenuResponsive('buttonMenu', 'block-system-menu-block-menu-responsive', 'active');

    // UI Theme
    new UI();

    // Slider
    // new Slider();
})
